import React from 'react';
import { PSPType } from 'stores/types';

type PspFilterPropTypes = {
    psp: PSPType;
    onChangePsp: (psp :PSPType) => void;
}

const PspFilter: React.FC<PspFilterPropTypes> = ({onChangePsp, psp}) => {
    const setPsp = (e:any) => {
        onChangePsp(e.target.value);
    }
    return (
        <select title='all psp' value={psp} onChange={setPsp} className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'>
          <option value="">all psp</option>
          <option value="cashfree" >cashfree</option>
          <option value="axis" >axis</option>
        </select>
    )
}

export default PspFilter;